import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { X, MousePointerClick, ZoomIn, ArrowLeftRight, Sparkles } from 'lucide-react'

const TreeInstructionsTooltip = () => {
    const { t } = useTranslation()
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const lastShown = localStorage.getItem('treeInstructionsLastShown')
        const currentTime = new Date().getTime()

        if (!lastShown || currentTime - parseInt(lastShown) > 14 * 24 * 60 * 60 * 1000) {
            setIsVisible(true)
            localStorage.setItem('treeInstructionsLastShown', currentTime.toString())
        }
    }, [])

    window.showTreeInstructions = () => setIsVisible(true)

    const handleClose = () => {
        setIsVisible(false)
    }

    if (!isVisible) return null

    return (
        <div className="hidden md:block">
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                <div className="bg-white border-2 border-[#e6dfd4] rounded-lg shadow-lg p-6 max-w-md mx-4 relative">
                    <button
                        onClick={handleClose}
                        className="absolute top-3 left-3 p-1.5 hover:bg-gray-100 rounded-full transition-colors"
                    >
                        <X className="h-5 w-5 text-[#937c5d]" />
                    </button>

                    <h3 className="text-xl font-bold mb-6 text-[#4a3f30] text-center">
                        {t('treeInstructions.welcome')}
                    </h3>

                    <div className="space-y-4 px-2">
                        <div className="flex items-center gap-3 text-[#937c5d]">
                            <MousePointerClick className="h-6 w-6 flex-shrink-0"/>
                            <span className="text-lg">{t('treeInstructions.click')}</span>
                        </div>

                        <div className="flex items-center gap-3 text-[#937c5d]">
                            <ZoomIn className="h-6 w-6 flex-shrink-0"/>
                            <span className="text-lg">{t('treeInstructions.zoom')}</span>
                        </div>

                        <div className="flex items-center gap-3 text-[#937c5d]">
                            <ArrowLeftRight className="h-6 w-6 flex-shrink-0"/>
                            <span className="text-lg">{t('treeInstructions.drag')}</span>
                        </div>

                        <div className="flex items-center gap-3 text-[#937c5d] bg-[#fcf9f2] p-3 rounded-lg">
                            <Sparkles className="h-6 w-6 flex-shrink-0 text-[#d4af37]"/>
                            <span className="text-lg">{t('treeInstructions.bonus')}</span>
                        </div>
                    </div>

                    <div className="mt-6 text-center">
                        <button
                            onClick={handleClose}
                            className="px-6 py-2 bg-[#937c5d] text-white rounded-lg hover:bg-[#7c6849] transition-colors"
                        >
                            {t('treeInstructions.understood')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TreeInstructionsTooltip